import script from "./Purches.vue?vue&type=script&setup=true&lang=js"
export * from "./Purches.vue?vue&type=script&setup=true&lang=js"

import "./Purches.vue?vue&type=style&index=0&id=7dd3912a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd3912a"]])

export default __exports__